import React from 'react';

import SecondaryCta from 'components/Buttons/SecondaryCta';

const PlainSecondaryCta = props => (
  <SecondaryCta
    sx={theme => ({
      letterSpacing: 'normal',
      textTransform: 'none',
      fontFamily: theme.typography.fontFamily
    })}
    {...props}
  />
);

export default PlainSecondaryCta;
